import React, { FC } from "react";
import { Box } from "@mui/material";

export const LineY: FC = () => (
    <Box
      sx={{
        position: "absolute",
        top: theme => `-${theme.spacing(5)}`,
        transform: "translateY(-100%)",
        left: 0,
        width: 1,
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        bottom: 0,
        height: "50vh",
        minHeight: 100
      }}
    >
      <Box
        sx={{
          width: "2px",
          height: "100%",
          flexGrow: 1,
          backgroundColor: theme => theme.palette.background.default
        }}
      />
      <Box
        sx={{
          width: "12px",
          height: "12px",
          borderRadius: "6px",
          backgroundColor: theme => theme.palette.background.default,
          flexShrink: 0
        }}
      />
    </Box>
  );
